import { render, staticRenderFns } from "./veHqYiliaoShow.vue?vue&type=template&id=30b36928&scoped=true"
import script from "./veHqYiliaoShow.vue?vue&type=script&lang=js"
export * from "./veHqYiliaoShow.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "30b36928",
  null
  
)

export default component.exports